import { useQuery } from 'react-query';
import { axios } from '../api/axios';

export default function useGetGuide() {
  const query = useQuery('get/content/guide', () => axios.get('/get/content/guide/'), {
    cacheTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return [query.data, query];
}
